export default __webpack_public_path__ + "static/media/entrance_white.6a4c1ce3.svg";